<div class="title-container">
  <ng-container *ngTemplateOutlet="titleTemplate; context: { $implicit: titles?.[0] ?? null }"> </ng-container>

  <ng-container *ngIf="titles.length > 1">
    <div class="second-title-with-extra">
      <ng-container *ngTemplateOutlet="titleTemplate; context: { $implicit: titles[1] }"> </ng-container>

      <div *ngIf="titles.length > 2" class="extra-titles" [matMenuTriggerFor]="titleTooltipMenu" [matMenuTriggerData]="{ titles: titles }">
        +{{ titles.length - 2 }}
      </div>
    </div>
  </ng-container>
</div>

<mat-menu #titleTooltipMenu="matMenu" class="tooltip-menu" yPosition="above" xPosition="after">
  <ng-template matMenuContent let-data="titles">
    <ng-container *ngFor="let title of data | slice: 2">
      <ng-container *ngTemplateOutlet="titleTemplate; context: { $implicit: title }"> </ng-container>
    </ng-container>
  </ng-template>
</mat-menu>

<ng-template #titleTemplate let-title>
  <app-status-label [label]="title" [shouldCropLabel]="true"></app-status-label>
</ng-template>
